import { useContext, useState } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

import Button from '../../../../reusable/button/button.component';

import Client from '../../../../../tools/client';
import { ToastContext } from '../../../../../contexts/toast.context';

import { 
  MainContainer 
} from '../../../../../styles/component.styles';

const client = new Client();

const RecaptchaIntegrationPanel = ({ integration }) => {
  const [captchaToken, setCaptchaToken] = useState(null);
  const [loading, setLoading] = useState(false);
  const { successToast, errorToast } = useContext(ToastContext);

  const siteKey = integration?.secrets?.find(s => s.keyName === 'siteKey')?.value;

  const handleVerify = async () => {
    if (!captchaToken) {
      errorToast('Please complete the CAPTCHA before testing.');
      return;
    }

    setLoading(true);
    try {
      // 🔥 Only send the token — the siteKey is not needed server-side
      const res = await client.testIntegrationById(integration.id, { token: captchaToken });

      if (res.success) {
        successToast('reCAPTCHA key is valid.');
      } else {
        errorToast(`Validation failed: ${res.message || 'Unknown error'}`);
      }
    } catch (err) {
      console.error('reCAPTCHA test error:', err);
      errorToast('Error validating reCAPTCHA. Check console for details.');
    } finally {
      setLoading(false);
    }
  };

  if (!siteKey) {
    return (
      <MainContainer>
        <p style={{ marginTop: '1rem', color: 'red' }}>Missing siteKey for this integration.</p>
      </MainContainer>
    );
  }

  return (
    <MainContainer>
      <ReCAPTCHA
        sitekey={siteKey}
        onChange={setCaptchaToken}
        size="compact"
      />

      <Button
        style={{ marginTop: '1rem' }}
        onClick={handleVerify}
        disabled={!captchaToken || loading}
      >
        {loading ? 'Testing...' : 'Test reCAPTCHA'}
      </Button>
    </MainContainer>
  );
};

export default RecaptchaIntegrationPanel;